import React from "react";
import Alert from "./Alert";
import Storage from "./Storage";
import Logout from "./utils";
import {Container} from "react-bootstrap";

export default class UPSInvoiceUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            returns: [],
            transportations: [],
            adjustments: [],
            alert: '',
            loading: true,
        };
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status"></div>
                </div>
            )
        }
        if (this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }
        let user = '';
        switch (this.props.match.params.user) {
            case 'novaposhta':
                user = 'NovaPoshta';
                break
            case 'boxberry':
                user = 'Boxberry';
                break
            default:
                user = 'UNKNOWN'
        }
        const invoiceNumber = this.props.match.params.invoiceNumber;
        const returns = this.state.returns;
        let totalReturns = 0;
        const transportations = this.state.transportations;
        let totalTransportations = 0;
        let totalParcels = 0;
        const adjustments = this.state.adjustments;
        let totalAdjustments = 0;
        return (
            <Container>
                <h4 className="mt-4">{user} [<small><a href={'/ups-invoices/'+invoiceNumber}>{invoiceNumber}</a></small>]</h4>
                <div>
                    {returns.length === 0 ? null :
                        <div>
                            <h6 className="mt-2 text-center" style={{'background-color': '#fff10045'}}><b>RETURNS</b></h6>
                            <table className="table table-sm">
                                <thead>
                                <tr>
                                    <th>Track</th>
                                    <th>Net charge</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    returns.map((v, i) => {
                                        totalReturns += v.net_charge_cents;
                                        return (
                                            <tr key={i}>
                                                <td><a href={'/packages/' + v.tracking_number}>{v.tracking_number}</a></td>
                                                <td>{Number(v.net_charge_cents / 100).toLocaleString()}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td colSpan="1"><b>TOTAL</b></td>
                                    <td><b>{Number(totalReturns / 100).toLocaleString()}</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    }

                    {transportations.length === 0 ? null :
                        <div>
                            <h6 className="mt-2 text-center" style={{'background-color': '#fff10045'}}><b>TRANSPORTATIONS</b></h6>
                            <table className="table table-sm">
                                <thead>
                                <tr>
                                    <th>MAWB</th>
                                    <th>Parcels</th>
                                    <th>Net charge</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    transportations.map((v, i) => {
                                        totalTransportations += v.net_charge_cents;
                                        totalParcels += v.parcel_count;
                                        return (
                                            <tr key={i}>
                                                <td><a href={'/' + v.mawb}>{v.mawb}</a></td>
                                                <td>{v.parcel_count}</td>
                                                <td>{Number(v.net_charge_cents / 100).toLocaleString()}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td><b>TOTAL</b></td>
                                    <td><b>{Number(totalParcels).toLocaleString()}</b></td>
                                    <td><b>{Number(totalTransportations / 100).toLocaleString()}</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    }

                    {adjustments.length === 0 ? null :
                        <div>
                            <h6 className="mt-2 text-center" style={{'background-color': '#fff10045'}}><b>ADJUSTMENTS</b></h6>
                            <table className="table table-sm">
                                <thead>
                                <tr>
                                    <th>Track</th>
                                    <th>Category</th>
                                    <th>Net charge</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    adjustments.map((v, i) => {
                                        totalAdjustments += v.net_charge_cents;
                                        return (
                                            <tr key={i}>
                                                <td><a href={'/packages/' + v.tracking_number}>{v.tracking_number}</a></td>
                                                <td>{v.charge_category}</td>
                                                <td>{Number(v.net_charge_cents / 100).toLocaleString()}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td colSpan="2"><b>TOTAL</b></td>
                                    <td><b>{Number(totalAdjustments / 100).toLocaleString()}</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                </div>

            </Container>
        )
    }

    componentDidMount() {
        fetch(`/api/v1/admin/ups-invoices/${this.props.match.params.invoiceNumber}/users/${this.props.match.params.user}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${Storage.getToken()}`},
        })
            .then(response => {
                switch (response.status) {
                    case 200:
                        response.json()
                            .then(data => {
                                this.setState({
                                    returns: data.returns,
                                    transportations: data.transportations,
                                    adjustments: data.adjustments,
                                })
                            })
                            .catch(err => {
                                this.setState({alert: JSON.stringify(err)});
                            })
                        return
                    case 401:
                        Logout();
                        return
                    default:
                        this.setState({alert: 'Invalid status: ' + response.status});
                        return
                }
            })
            .catch(err => {
                this.setState({alert: JSON.stringify(err)});
            })
            .finally(_ => {
                this.setState({loading: false})
            })
    }
}